import { BlogSection } from "@/types/blog";

export const leistungskultur: BlogSection = {
  id: "leistungskultur",
  title: "Wenn Leistungskultur Krankheit pathologisiert",
  content: `
    <p>Wir leben in einer Gesellschaft, die Ruhe mit Rückstand verwechselt. „Ich bin krank" wirkt wie ein Störfaktor in der Effizienzmaschine. Doch Krankheit ist kein Versagen, sondern Teil biologischer Intelligenz.</p>
    
    <p>Organisationen messen Produktivität in Durchläufen, nicht in Rhythmen. Dabei weiß die Neurobiologie längst: Regeneration ist kein Luxus, sondern Leistungsgrundlage. Fehlt sie, kippt das System. Emotional, kognitiv und körperlich.</p>
    
    <h3>Erschöpfung als Zugang zur Selbstwahrnehmung</h3>
    
    <p>Viele Menschen finden erst durch Krankheit oder Erschöpfung zu einem realistischen Selbstbild. Wenn der Körper nicht mehr mitmacht, entsteht Raum für Fragen:</p>
    
    <ul>
      <li>„Was treibt mich wirklich an?"</li>
      <li>„Was wäre genug?"</li>
    </ul>
    
    <p>Das ist keine Esoterik, sondern neurobiologische Konsequenz: Im Zustand der Schwäche lässt die Reizflut nach. Das Gehirn sortiert neu. Selbstführung heißt, diese Pause nicht zu fürchten, sondern zu nutzen.</p>
    
    <h3>Gesunde Organisationen denken in Wellen, nicht in Linien</h3>
    
    <p>Zukunftsorientierte Unternehmen integrieren Regeneration als Teil der Wertschöpfung:</p>
    
    <ul>
      <li>Zyklische Arbeitsmodelle statt Dauerverfügbarkeit</li>
      <li>Mikropausen und Entkopplungszeiten als Struktur</li>
      <li>Führung, die Sicherheit vermittelt statt nur Ziele zu setzen</li>
    </ul>
    
    <p>So wird Gesundheit von einer privaten Angelegenheit zu einem Führungsthema. Und Krankheit verliert ihr Stigma.</p>
  `
};
